export function formatPhoneNumber (phone: string): string {
  const digits = phone.replace(/\D/g, '')

  if (digits.length !== 11) return phone

  let normalized = digits

  if (normalized.startsWith('8')) {
    normalized = '7' + normalized.slice(1)
  }

  if (!normalized.startsWith('7')) return phone

  const operatorCode = normalized.slice(1, 4)
  const part1 = normalized.slice(4, 7)
  const part2 = normalized.slice(7, 9)
  const part3 = normalized.slice(9, 11)

  return `+7 (${operatorCode}) ${part1}-${part2}-${part3}`
}
